export default "* Hvor lever sæler?\n* Hvad tror I sæler æder?\n* Hvordan tror I sæler kan holde varmen i det kolde vand?\n* Hvilken farve har sælens pels?";